import React from 'react';
import { FaFacebook, FaUsers, FaCheckCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';
import * as FaIcons from "react-icons/fa";
import parse from 'html-react-parser';
import { domToReact } from 'html-react-parser';

const CommunitySection = ({ webinarData, communities }) => {
  const Icon = ({ iconName, className }) => {
    const IconComponent = FaIcons[iconName];
    if (!IconComponent) return null;
    return <IconComponent className={className} />;
  };

  // Function to add icons before each paragraph
  const renderBenefitsWithIcons = (htmlContent) => {
    if (!htmlContent) return null;
    
    // Parse HTML and add icons
    const parsed = parse(htmlContent, {
      replace: (domNode) => {
        if (domNode.type === 'tag' && domNode.name === 'p') {
          return (
            <div key={domNode.attribs?.id || Math.random()} className="flex items-start mb-3">
              <FaCheckCircle className="text-blue-500 mt-1 mr-3 flex-shrink-0" />
              <div className="text-gray-700">
                {domToReact(domNode.children)}
              </div>
            </div>
          );
        }
        return null;
      }
    });
    
    return parsed;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.5 }}
      className="mb-8 px-4 my-4 sm:px-0"
    >
      {communities && communities.map((community, index) => (
        <div key={index} className="relative overflow-hidden rounded-2xl shadow-xl border border-blue-100 bg-gradient-to-br from-blue-50 to-indigo-50">
          {/* Facebook icon decoration */}
          <div className="absolute -top-8 -right-8 text-blue-200 opacity-30" style={{ fontSize: '10rem' }}>
            <Icon iconName={community.icon} />
          </div>
          
          <div className="relative z-10 p-6">
            {/* Header with icon */}
            <div className="flex items-center mb-4">
              <div className="bg-white p-3 rounded-xl shadow-sm mr-4 text-blue-600">
                <FaUsers className="text-xl" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800">{community.title}</h3>
                <p className="text-blue-600 text-sm font-medium">{community.subtitle}</p>
              </div>
            </div>

            {/* Benefits list */}
            <div className="mb-6">
              {renderBenefitsWithIcons(community.benefits)}
            </div>

            {/* Join button with animation */}
            <motion.a
              whileHover={{ 
                scale: 1.02,
                boxShadow: "0 10px 20px rgba(59, 130, 246, 0.3)"
              }}
              whileTap={{ scale: 0.98 }}
              href={community.facebook_group_link || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-blue-600 hover:bg-blue-700 text-white py-4 px-6 rounded-xl font-bold shadow-lg text-center"
            >
              <div className="flex items-center justify-center">
                <Icon iconName={community.button_icon}  className="mr-3 text-xl" />
                <span>{community.button_text}</span>
              </div>
            </motion.a>
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default CommunitySection;